import { render, staticRenderFns } from "./moveTab.vue?vue&type=template&id=09e10002&"
import script from "./moveTab.vue?vue&type=script&lang=js&"
export * from "./moveTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports